export const DEFAULT_TABLE_PAGE_SIZE = 10

export const AUTOCOMPLETE_DEFAULT_PAGE = 1
export const AUTOCOMPLETE_DEFAULT_PAGE_SIZE = 10
export const AUTOCOMPLETE_DEFAULT_SEARCHING = ''
